import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { isEqual } from 'lodash';
import { Observable, Subject, takeUntil } from 'rxjs';
import { updateTenderItemForm } from 'src/app/core/store/form.actions';
import {
  DropDownOptions,
  MyPurchaseForm,
  StoreDropdowns,
  TenderItemFormI,
} from 'src/app/shared/models/app-models';
import { DeliveryAddressI } from 'src/app/shared/models/database-models';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_DATE_FORMAT } from 'src/app/data/constants/Data';
import * as moment from 'moment';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';

@Component({
  selector: 'app-tender-item',
  templateUrl: './tender-item.component.html',
  styleUrls: ['./tender-item.component.scss'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
  { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }]
})
export class TenderItemComponent implements OnInit, OnChanges {
  @Input() isReadOnly: boolean = false;
  tenderForm!: FormGroup;
  TargetScheduleDateControl!: FormControl;
  DeliveryAddressControl!: FormControl;
  PleaseSpecifyControl!: FormControl;
  minDate: Date = new Date()
  deliveryAddressDropdown: DropDownOptions[] = [];
  store$: Observable<MyPurchaseForm>;
  destroy$: Subject<boolean> = new Subject<boolean>();
  tenderItem!: TenderItemFormI;
  purchaseType: string = '';
  constructor(
    private _fb: FormBuilder,
    private route: ActivatedRoute, private permissionsService: PermissionsService,
    private store: Store<{
      form: MyPurchaseForm;
      dp: StoreDropdowns;
    }>
  ) {
    this.store$ = this.store.select('form');
    this.purchaseType = this.route.snapshot.params['purchaseType'].split(';')[0] as string;
    this.tenderForm = this._fb.group({
      TargetScheduleDate: null,
      DeliveryAddress: { id: '', value: '' },
      PleaseSpecify: '',
    });
    this.TargetScheduleDateControl = this.tenderForm.controls[
      'TargetScheduleDate'
    ] as FormControl;
    this.DeliveryAddressControl = this.tenderForm.controls[
      'DeliveryAddress'
    ] as FormControl;
    this.PleaseSpecifyControl = this.tenderForm.controls[
      'PleaseSpecify'
    ] as FormControl;
  }
  async ngOnInit(): Promise<void> {
    this.store$
      .pipe(takeUntil(this.destroy$))
      .subscribe((s: MyPurchaseForm) => {        
        if (s.TenderItem) {
          this.tenderItem = s.TenderItem as TenderItemFormI;
          this.updateFormControls();
        }
      });
    this.tenderForm.valueChanges.subscribe((rawValue: any) => {
      if (this.isReadOnly && !this.tenderForm.dirty) return
      let value: any = {};
      const dateRegex = /^(0[1-9]|[1-2][0-9]|3[0-1])\/(0[1-9]|1[0-2])\/\d{4}$/;
      if (typeof this.TargetScheduleDateControl.getRawValue()?._i === 'string' && !dateRegex.test(this.TargetScheduleDateControl.getRawValue()._i)) {
        value = {
          ...rawValue,
          TargetScheduleDate: null
        }
      }
      else if (this.TargetScheduleDateControl.getRawValue() && !this.isDateValid(this.TargetScheduleDateControl.getRawValue().toDate(), new Date())) {
        value = {
          ...rawValue,
          TargetScheduleDate: null
        }
      }
      else {
        value = {
          ...rawValue,
          TargetScheduleDate: this.TargetScheduleDateControl.getRawValue() ? this.TargetScheduleDateControl.getRawValue().toDate().toISOString() : null
        }
      }
      console.log('entered input target schedule date', this.minDate)
      console.log('original input target schedule date', this.tenderItem)
      if (isEqual(value, this.tenderItem)) return
      this.updateForm(value);
    });
    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.deliveryAddressDropdown = dp.DeliveryAddress || [];
      });
  }
  isDateValid(date1: Date, date2: Date): boolean {
    if (date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()) {
        return true;
    } else if (date1 > date2) {
        return true;
    } else {
        return false;
    }
}
  convertUTCToSGT(date: Date) {
    date.setHours(date.getHours() + 8)
    return date
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isReadOnly"]) {
      if (changes["isReadOnly"].currentValue == true) {
        this.tenderForm.disable();
      }
      else {
        this.tenderForm.enable();
      }
    }
  }

  updateForm(value: any) {
    this.store.dispatch(
      updateTenderItemForm({ form: { ...value } })
    );
  }
  updateFormControls() {
    if (this.tenderItem.TargetScheduleDate && this.tenderItem.TargetScheduleDate.length > 0) {
      let date: Date = new Date(this.tenderItem.TargetScheduleDate)
      this.tenderForm.setValue({
        ...this.tenderItem,
        TargetScheduleDate: moment({ year: date.getFullYear(), month: date.getMonth(), date: date.getDate() })
      });
    }
    else
      this.tenderForm.setValue({
        ...this.tenderItem,
        TargetScheduleDate: null
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
